import { TextField } from '@mui/material';
import ReactInputMask from 'react-input-mask';
import { useEffect, useState } from 'react';

interface Props {
  label: string;
  value: string;
  name: string;
  className?: string;
  error?: any;
  hasError?: boolean;
  handleBlur?: (e: any) => void;
  handleChange?: (e: any) => void;
  disabled?: boolean;
  required?: boolean;
  setMessage?: string;
  cpfCnpjValue?: string;
}

export const InputIE = ({
  label,
  value,
  name,
  className,
  error,
  hasError,
  handleBlur,
  handleChange,
  disabled,
}: Props) => {
  const [mask, setMask] = useState('999.999.999/-999'); // Inicialmente o formato de RG

  const updateMask = (inputValue: string) => { 
    if (inputValue.length > 9) {
      setMask('999.999.999/999'); // Altera para formato de IE
    } else {
      setMask('99.999.999-99'); // Altera para formato de RG
    }
  }
    
  useEffect(() => {
    if (value) { updateMask(value.replace(/\D/g, '')); }
  }, [value]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value.replace(/\D/g, '');

    updateMask(inputValue);
    if (handleChange) {
      handleChange(e); // Chama a função handleChange passada via props
    }
  };
  
  return (
    <ReactInputMask
      disabled={disabled}
      id={name}
      mask={mask}
      value={value}
      maskChar=' '
      onBlur={handleBlur}
      onChange={handleInputChange}      
    >
      {/*// @ts-expect-error - .*/}
      {() => (
        <TextField
          size='small'
          disabled={disabled}
          name={name}
          InputLabelProps={{ shrink: true }}
          label={label}
          className={className}
          error={hasError}
          helperText={error}
        />
      )}
    </ReactInputMask>
  );
};
